import styled, { css } from 'styled-components';
var iconSizes = {
  16: '0.8pt',
  24: '1pt',
  32: '1.2pt',
  48: '1.4pt',
  64: '1.6pt'
};
export default styled.svg.withConfig({
  displayName: "Svg",
  componentId: "sc-1usfroi-0"
})(["", ";*{vector-effect:non-scaling-stroke;}*[fill='#181818']{fill:", ";}*[stroke='#181818']{stroke:", ";}"], function (props) {
  return css(["stroke-width:", ";"], iconSizes[props.iconSize]);
}, function (props) {
  return props.iconColor;
}, function (props) {
  return props.iconColor;
});